module.exports = __webpack_public_path__ + "static/media/logo2.cf9b3d86.jpg";